// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__1VtLy","navLink":"Navigation_navLink__2U8pw","activeLink":"Navigation_activeLink__2rUFB Navigation_navLink__2U8pw"};